module.exports = __webpack_public_path__ + "static/media/map-marker.af754b36.svg";